import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var userDataEstas = localStorage.getItem("userDataEstas") ? JSON.parse(base64.decode(localStorage.getItem("userDataEstas"))) : "";
var haberService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/kucuk/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/enkucuk/",
    path : "https://www.estasmedikal.com/",
    tanimlama(kategori, link, baslik, altBaslik, icerik, seoBaslik, seoIcerik, resimList, resimKonum, menuKonum,
              galeriKonum, baslamaTarihi, bitisTarihi,sayac,begen,durum,dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                link: link,
                kategori: kategori,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                sayac: sayac,
                begen: begen,
                durum: durum,
                dil: dil,
                serviceName: "haber",
                methodName: "haberTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberCount(durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
               yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                durum: durum,
                serviceName: "haber",
                methodName: "haberCount"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberListDetay(kategoriKodu, baslangic, limit, durum,dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
               yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                dil: dil,
                serviceName: "haber",
                methodName: "haberListDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberDurumGuncelle(haberKodu, durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
               yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                haberKodu: haberKodu,
                durum: durum,
                serviceName: "haber",
                methodName: "haberDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberDetay(haberKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
               yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                haberKodu: haberKodu,
                serviceName: "haber",
                methodName: "haberDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberGuncelleme(haberKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
               yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                haberKodu: haberKodu,
                updateList: updateList,
                serviceName: "haber",
                methodName: "haberGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

};
export default haberService